export default {"src":"/_next/static/media/mobile-icon.ae377e35.svg","height":40,"width":40};